import { TabInfoList } from '@/types/appSettings'

export enum TabSettingName {
  basicInfo = 'basicInfo',
  laboTest = 'laboTest',
  vitalSign = 'vitalSign',
  ecg = 'ecg',
  dicom = 'dicom',
  image = 'image',
  document = 'document',
  dispensation = 'dispensation',
  prescription = 'prescription',
  medicationInstruction = 'medicationInstruction',
  bloodSugarLevel = 'bloodSugarLevel',
  hd = 'hd',
  pd = 'pd'
}

export const Tabs: TabInfoList = {
  [TabSettingName.basicInfo]: {
    routeName: 'BasicInfoTab',
    label: '基本情報',
    title: '基本情報',
    css: 'tab_kihon',
    wrapCss: 'content_kihon'
  },
  [TabSettingName.laboTest]: {
    routeName: 'LaboTestTab',
    label: '検査データ',
    title: '検査データ',
    css: 'tab_data',
    wrapCss: 'content_data'
  },
  [TabSettingName.vitalSign]: {
    routeName: 'VitalSignTab',
    label: 'バイタル',
    title: 'バイタル',
    css: 'tab_vital',
    wrapCss: 'content_vital'
  },
  [TabSettingName.ecg]: {
    routeName: 'EcgTab',
    label: '心電図',
    title: '心電図',
    css: 'tab_shindenzu',
    wrapCss: 'content_shindenzu'
  },
  [TabSettingName.dicom]: {
    routeName: 'DicomTab',
    label: '医用画像',
    title: '医用画像一覧',
    css: 'tab_img',
    wrapCss: 'content_img',
    children: [
      {
        routeName: 'DicomTabIndex',
        title: '医用画像一覧'
      },
      {
        routeName: 'DicomTabUpload',
        title: '医用画像アップロード'
      },
      {
        routeName: 'DicomTabEdit',
        title: '医用画像編集'
      }
    ]
  },
  [TabSettingName.image]: {
    routeName: 'ImageTab',
    label: 'その他画像',
    title: 'その他画像一覧',
    css: 'tab_otherimg',
    wrapCss: 'content_otherimg',
    children: [
      {
        routeName: 'ImageTabIndex',
        title: 'その他画像一覧'
      },
      {
        routeName: 'ImageTabUpload',
        title: 'その他画像アップロード'
      },
      {
        routeName: 'ImageTabEdit',
        title: 'その他画像編集'
      }
    ]
  },
  [TabSettingName.document]: {
    routeName: 'DocumentTab',
    label: '文書類',
    title: '文書一覧',
    css: 'tab_bunsho',
    wrapCss: 'content_bunsho',
    children: [
      {
        routeName: 'DocumentTabIndex',
        title: '文書一覧'
      },
      {
        routeName: 'DocumentTabUpload',
        title: '文書類アップロード'
      },
      {
        routeName: 'DocumentTabEdit',
        title: '文書類編集'
      }
    ]
  },
  [TabSettingName.dispensation]: {
    routeName: 'DispensationTab',
    label: '調剤歴',
    title: '調剤歴一覧',
    css: 'tab_chozai',
    wrapCss: 'content_chozai',
    children: [
      {
        routeName: 'DispensationCheckTab',
        title: '服用状況チェック'
      },
      {
        routeName: 'DispensationCreateTab',
        title: '調剤入力'
      },
      {
        routeName: 'DispensationCalendarTab',
        title: '服用カレンダー'
      }
    ]
  },
  [TabSettingName.prescription]: {
    routeName: 'PrescriptionTab',
    label: '処方歴',
    title: '処方カレンダー',
    css: 'tab_shohoreki',
    wrapCss: 'content_shohoreki'
  },
  [TabSettingName.medicationInstruction]: {
    routeName: 'MedicationInstructionTab',
    label: '服薬指導',
    title: '服薬指導',
    css: 'tab_fukuyaku',
    wrapCss: 'content_fukuyaku'
  },
  [TabSettingName.bloodSugarLevel]: {
    routeName: 'BloodSugarLevelTab',
    label: '血糖手帳',
    title: '血糖手帳',
    css: 'tab_kettou',
    wrapCss: 'content_kettou'
  },
  [TabSettingName.hd]: {
    routeName: 'HdTab',
    label: '血液浄化法',
    title: '血液浄化法',
    css: 'tab_hhd',
    wrapCss: 'content_hhd',
    children: [
      {
        wrapCss: ['content_hhd', 'content_hhd_input'],
        routeName: 'HdTabSetting',
        title: '透析条件・しきい値設定'
      }
    ]
  },
  [TabSettingName.pd]: {
    routeName: 'PdTab',
    label: '腹膜透析',
    title: '腹膜透析',
    css: 'tab_pd',
    wrapCss: 'content_pd',
    children: [
      {
        wrapCss: ['content_pd', 'pd_signup'],
        routeName: 'PdTabCreate',
        title: '腹膜透析記録'
      }
    ]
  }
}
